import React from "react";
import AdvancedTable from 'components/LM/common/AdvancedTable';
import K2Api from "lib/ajax/K2Api";
import DateFormat from "components/LM/common/DateFormat";
import FormDatesSearch from "components/LM/common/FormDatesSearch";

const TABLE_COLUMNS = [
	{
		name: "actor",
		alias: "Actor"
	},
	{
		name: "message",
		alias: "Message"
	},
	{
		name: "date",
		alias: "Date"
	}
];

function LogDisplay(props) {
	const {profileId, type} = props;

	return (
		<AdvancedTable
			columns={TABLE_COLUMNS}
			onSearch={params => logsSearch(type, profileId, params)}
			onResults={processResponse}
		>
			<FormDatesSearch />
		</AdvancedTable>
	)
}

async function logsSearch(type, profileId, {beginDate, endDate, page, pageSize}) {
	const from = (page - 1) * pageSize;
	const request = {beginDate, endDate, from, size: pageSize};

	const k2Api = new K2Api();
	const response = await k2Api.get(`/socialmedia/${type}/logs/${profileId}`, {params: request});
	return response.data;
}

function processResponse(response) {
	const total = response.total;
	const rows = response.logs.map((row, index) => {
		return {
			...row,
			id: index,
			date: <DateFormat>{row.date}</DateFormat>,
		}
	});
	return {total, rows};
}

export default LogDisplay;
